import { Component, OnInit } from '@angular/core';
// import { LocalService } from './service/local.service'; // Your local storage service
import { LocalService } from '../_services/local.service';
import { AuthService } from '../core/auth/auth.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
  model: any[] = []; 
  userRole: string = '';  

  allMenuItems: any[] = [];

  constructor(private _localService: LocalService, private _authService : AuthService) {}

  ngOnInit() {
    this.filterMenuByRole();  
  }

  filterMenuByRole() {
    if(this._authService.isSuperAdmin()) {
        this.allMenuItems = [
            {
              label: 'Home',
              items: [
                { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard/admindashboard'] },
                { label: 'User And Course Report', icon: 'pi pi-fw pi-file', routerLink: ['/dashboard/userAndCoursesReport'] }
              ]
            },
            {
              label: 'UMS',
              items: [
                { label: 'User', icon: 'pi pi-fw pi-bookmark', routerLink: ['/ums/user'] },
                { label: 'Roles', icon: 'pi pi-fw pi-bookmark', routerLink: ['/ums/role'] },
              ]
            },
            {
              label: 'Courses',
              items: [
                { label: 'Add Courses', icon: 'pi pi-fw pi-bookmark', routerLink: ['/courses/addCourses'] },
                { label: 'Courses List', icon: 'pi pi-fw pi-bookmark', routerLink: ['/courses/CoursesList'] },
              ]
            }
        ];
    } else if (this._authService.isStudent()) {
        this.allMenuItems = [];
    } else if (this._authService.isAdmin()) {
            this.allMenuItems = [
                {
                  label: 'Home',
                  items: [
                    { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard/admindashboard'] },
                    { label: 'User And Course Report', icon: 'pi pi-fw pi-file', routerLink: ['/dashboard/userAndCoursesReport'] }

                  ]
                },
                {
                  label: 'UMS',
                  items: [
                    { label: 'User', icon: 'pi pi-fw pi-bookmark', routerLink: ['/ums/user'] },
                    { label: 'Roles', icon: 'pi pi-fw pi-bookmark', routerLink: ['/ums/role'] },
                  ]
                }
            ];
    } else if (this._authService.isCourseCreator()) {
        this.allMenuItems = [
             {
                  label: 'Home',
                  items: [
                    { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard/admindashboard'] },
                    { label: 'User And Course Report', icon: 'pi pi-fw pi-file', routerLink: ['/dashboard/userAndCoursesReport'] }

                  ]
              },
              {
              label: 'Courses',
              items: [
                { label: 'Add Courses', icon: 'pi pi-fw pi-bookmark', routerLink: ['/courses/addCourses'] },
                { label: 'Courses List', icon: 'pi pi-fw pi-bookmark', routerLink: ['/courses/CoursesList'] },
              ]
              }
        ];
    }
    
    this.model = [];

    this.allMenuItems.forEach(menu => {
      let filteredMenu = { ...menu }; 

    //   filteredMenu.items = filteredMenu.items.filter((item:any) => {
    //     if (this._authService.isStudent()) {
    //       return false;
    //     } else if (this.userRole === 'coursecreator') {
    //       return item.label === 'Add Courses' || item.label === 'Courses List';
    //     } else if (this._authService.) {
          
    //       return true;
    //     }
    //     return false;
    //   });

      if (filteredMenu.items.length > 0) {
        this.model.push(filteredMenu);
      }
    });



this._localService.setValue("userPermissions",this.allMenuItems)


  }
}
